import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const PasswordInput = forwardRef(function PasswordInput({ className, ...props }, ref) {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"] || "password";
  return (
    <div className="relative w-full">
      <Input ref={ref} {...props} type={show ? "text" : "password"} className={cn("pr-10", className)} />
      <button type="button" tabIndex={-1} data-testid={`${tid}-toggle`} aria-label={show ? "Hide password" : "Show password"} onClick={() => setShow(!show)}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-slate-400 hover:text-slate-700">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>);
});
